export enum EApiCallStateNames {
  PROJECTS = 'PROJECTS',
  PROJECT_TASKS_LIST = 'PROJECT_TASKS_LIST',
  PROJECT_GENERAL_TASKS_LIST = 'PROJECT_GENERAL_TASKS_LIST',
  DIARY_TASKS_LIST = 'DIARY_TASKS_LIST',
  DOCUMENTS = 'DOCUMENTS',
  NOTES = 'NOTES',
  EXPENSE_FILE_ARCHIVE = 'EXPENSE_FILE_ARCHIVE',
}

export enum EApiRequestPartKeys {
  SEARCH = 'SEARCH',
  PAGINATION = 'PAGINATION',
  FILTERS = 'FILTERS',
  SORTING = 'SORTING',
  PROJECTS_SORT_CODE = 'PROJECTS_SORT_CODE',
  PROJECTS_SORT_NAME = 'PROJECTS_SORT_NAME',
  PROJECTS_SORT_STATUS = 'PROJECTS_SORT_STATUS',
  PROJECTS_SORT_TYPOLOGY = 'PROJECTS_SORT_TYPOLOGY',
  PROJECTS_SORT_END_DATE = 'PROJECTS_SORT_END_DATE',
  TASKS_SORT_NAME = 'TASKS_SORT_NAME',
  TASKS_SORT_END_DATE = 'TASKS_SORT_END_DATE',
  TASKS_SORT_STATUS = 'TASKS_SORT_STATUS',
  TASKS_SORT_ASSIGNED_TO_COSTUMER = 'TASKS_SORT_ASSIGNED_TO_COSTUMER',
  DOCUMENTS_SORT_NAME = 'DOCUMENTS_SORT_NAME',
  EXPENSE_FILE_ARCHIVE_SORT_EXPENSE_FILE_NAME = 'EXPENSE_FILE_ARCHIVE_SORT_EXPENSE_FILE_NAME',
  EXPENSE_FILE_ARCHIVE_SORT_EXPENSE_FILE_CREATED_AT = 'EXPENSE_FILE_ARCHIVE_SORT_EXPENSE_FILE_CREATED_AT',
  EXPENSE_FILE_ARCHIVE_SORT_PROJECT_NAME = 'EXPENSE_FILE_ARCHIVE_SORT_PROJECT_NAME',
  EXPENSE_FILE_ARCHIVE_SORT_PROJECT_END_DATE = 'EXPENSE_FILE_ARCHIVE_SORT_PROJECT_END_DATE',
  EXPENSE_FILE_ARCHIVE_SORT_PROJECT_PROVINCE = 'EXPENSE_FILE_ARCHIVE_SORT_PROJECT_PROVINCE',
  EXPENSE_FILE_ARCHIVE_SORT_PROJECT_TYPOLOGY = 'EXPENSE_FILE_ARCHIVE_SORT_PROJECT_TYPOLOGY',
  EXPENSE_FILE_ARCHIVE_SORT_PROJECT_CUSTOMER_NAME = 'EXPENSE_FILE_ARCHIVE_SORT_PROJECT_CUSTOMER_NAME',
  EXPENSE_FILE_ARCHIVE_SORT_EXPENSE_FILE_STATUS = 'EXPENSE_FILE_ARCHIVE_SORT_EXPENSE_FILE_STATUS',
}
